var React = require('react');

function ArrowRight (props) {
    return React.createElement("svg",props,[React.createElement("line",{"x1":"5","y1":"12","x2":"19","y2":"12","key":0}),React.createElement("polyline",{"points":"12 5 19 12 12 19","key":1})]);
}

ArrowRight.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","className":"feather feather-arrow-right"};

module.exports = ArrowRight;

ArrowRight.default = ArrowRight;
